// extracted by mini-css-extract-plugin
module.exports = {"stepTitle":"Steps_stepTitle__2WB6r","stepOl":"Steps_stepOl__hzDVW","gradient_list":"Steps_gradient_list__30NGC"};